import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { trpc } from '../../../utils/trpc';
import { EnvironmentContext } from '../context';

export const EnvSidebar = () => {
  const ctx = useContext(EnvironmentContext);
  const navigate = useNavigate();
  const environment = ctx.state.env;
  const environments = trpc.env.list.useQuery();

  return (
    <div className="md:basis-3/12 md:block hidden">
      <aside className="w-64" aria-label="Sidebar">
        <div className="overflow-y-auto py-4 px-3 rounded">
          <ul className="space-y-2">
            <li>
              <div className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100">
                <span className="ml-3 font-mono font-bold">Environments</span>
              </div>
            </li>
            {environments.isSuccess &&
              environments.data.map((env) => (
                <li key={env.id}>
                  <button
                    type="button"
                    onClick={() => navigate(`/dev/env/${env.id}`)}
                    className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100"
                  >
                    <span
                      className={`flex-1 ml-3 whitespace-nowrap font-mono ${
                        env.id === environment?.id ? 'font-bold' : ''
                      }`}
                    >
                      {env.name}
                    </span>
                  </button>
                </li>
              ))}
          </ul>
        </div>
      </aside>
    </div>
  );
};
